import { AccountRegion } from './schema'

export type RegionMap = {
  [region in AccountRegion]: string
}
export const REGIONS: RegionMap = {
  US_EAST_1: 'East Coast (us-east-1, Virginia)',
  US_WEST_1: 'West Coast (us-west-1, Oregon)',
}
